module.exports = __webpack_public_path__ + "img/icon-ok.56dffd5f.svg";